import { css } from "../../../styled-system/css";

export const styles = {
  divHeadlineWrapper: () =>
    css({
      paddingY: "baseUnit.mobile1",
      paddingX: "baseUnit.mobile2",
      backgroundColor: "white",
      position: "relative",
      left: "50%",
      width: "100vw",
      marginLeft: "-50vw",
      desktop: {
        paddingX: "baseUnit.mobile3",
        marginTop: 0,
        marginRight: 0,
        marginBottom: "baseUnit.mobile3",
        marginLeft: "-50vw",
      },
    }),
  headline: () =>
    css({
      color: "headlineGrey",
      marginBottom: 0,
    }),
};
